import React from "react";
import NightAuditPresenterDate from "./NightAuditPresenterDate";
import NightAuditPresenterSummary from "./NightAuditPresenterSummary";
import NightAuditPresenterLodging from "./NightAuditPresenterLodging";
import NightAuditPresenterTaxes from "./NightAuditPresenterTaxes";
import NightAuditPresenterFees from "./NightAuditPresenterFees";
import NightAuditPresenterProducts from "./NightAuditPresenterProducts";

class NightAuditFolioItemsPresenter extends React.Component {
  constructor(props){
    super(props);
  };

  render() {
    return(
      <div>
        <NightAuditPresenterDate {...this.props} />
        {/* <NightAuditPresenterSummary {...this.props} /> */}
        <NightAuditPresenterLodging {...this.props} />
        {/* {this.renderProducts()} */}
        {/* <NightAuditPresenterTaxes {...this.props} />
        <NightAuditPresenterFees {...this.props} /> */}
      </div>
    );
  };

  renderProducts() {
    return this.props.products.map(product => <NightAuditPresenterProducts {...this.props} product={product} key={product.id} />)
  };
};

export default NightAuditFolioItemsPresenter